import { render, staticRenderFns } from "./ApplyLayout.vue?vue&type=template&id=0d63c4dc&scoped=true&"
import script from "./ApplyLayout.vue?vue&type=script&lang=js&"
export * from "./ApplyLayout.vue?vue&type=script&lang=js&"
import style0 from "./ApplyLayout.vue?vue&type=style&index=0&id=0d63c4dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d63c4dc",
  null
  
)

export default component.exports